import { useRoutes,useNavigate } from "react-router-dom";
import Routers from './router';
import {useEffect} from "react"
import _ from "lodash"
import {baseURL} from "../src/apiSection/baseUrl"


function App() {
  let navigate=useNavigate();  
  const Redirectpath=(path)=>{
    navigate(path, { replace: false });
  }
  let element = useRoutes(Routers(Redirectpath));

   // 'development', 'test', or 'production'

   const nonce = btoa(Math.random().toString()).slice(0, 16); // Generate a random nonce

   let cspContent = `default-src 'self'; connect-src 'self' ${baseURL}; style-src 'self' 'unsafe-inline';`;
   
   const addCsp = ()=>{
    const metaTag = document.createElement('meta');
    metaTag.httpEquiv = 'Content-Security-Policy';
    metaTag.content = cspContent;
    document.head.appendChild(metaTag);
  
    // Add your inline style with the nonce
    const styleTag = document.createElement('style');
    styleTag.setAttribute('nonce', nonce);
    styleTag.innerHTML = `
      body { background-color: #f0f0f0; }
    `;
    document.head.appendChild(styleTag);
  
    return () => {
      document.head.removeChild(metaTag);
      document.head.removeChild(styleTag);
    };
   }
   useEffect(() => {
    addCsp()
   }, [cspContent]);
   


  return (
    <div style={{overflow: 'auto',}}>
      {element}
    </div>
  );
}

export default App;
